export type OperationsGrossTargets = Record<
  string,
  Record<string, { gross: number; rpm: number }>
>;

export const operationsGrossTargets: OperationsGrossTargets = {
  "2025-12": {
    rgn: { gross: 653400, rpm: 3.85 },
    flat: { gross: 737678, rpm: 2.55 },
    reefer: { gross: 394585, rpm: 3.1 },
    dryvan: { gross: 133714, rpm: 2.4 },
    step: { gross: 260357, rpm: 2.7 },
    conestoga: { gross: 86578, rpm: 2.5 },
    po: { gross: 44570, rpm: 2 },
  },
  "2026-01": {
    rgn: { gross: 653400, rpm: 3.85 },
    flat: { gross: 737678, rpm: 2.55 },
    reefer: { gross: 394585, rpm: 3.1 },
    dryvan: { gross: 133714, rpm: 2.4 },
    step: { gross: 260357, rpm: 2.7 },
    conestoga: { gross: 86578, rpm: 2.5 },
    po: { gross: 44570, rpm: 2 },
  },
};
